import type { Dict } from '@aviata/platform-types';

import type { WatchlistOffer } from '../types';

function stubCity(iata: string): Dict.Cities.City {
  return {
    iata,
    iata_code: iata,
    name: iata,
    name_en: iata,
    name_ru: iata,
    name_kk: iata,
    country: {
      iso_code: '',
      phone_code: '',
      name: '',
      name_en: '',
      name_ru: '',
      name_kk: '',
      regions: [],
    },
    airports: [],
  };
}

function stubAirport(iata: string): Dict.Locations.Location {
  return {
    iata,
    iata_code: iata,
    name: iata,
    name_en: iata,
    name_ru: iata,
    name_kk: iata,
    latitude: 0,
    longitude: 0,
    timezone: 'UTC',
    type: 'airport',
    city: stubCity(iata),
  };
}

function stubAirline(iata: string): Dict.Airlines.Airline {
  return {
    iata,
    iata_code: iata,
    name: iata,
    name_en: iata,
    name_ru: iata,
    name_kk: iata,
  };
}

/** Ensures airports/airlines exist in dict so mapFlight / SearchCardFlight won't crash. */
export function mergeWatchlistDict(
  partial: Partial<Dict.Entity> | undefined,
  offer: WatchlistOffer | null | undefined,
): Dict.Entity {
  const dict: Dict.Entity = {
    airlines: { ...(partial?.airlines ?? {}) },
    airports: { ...(partial?.airports ?? {}) },
    cities: { ...(partial?.cities ?? {}) },
  };

  if (!offer?.flights?.length) {
    return dict;
  }

  for (const flight of offer.flights) {
    for (const segment of flight.segments) {
      if (!dict.airports[segment.dep.airport]) {
        dict.airports[segment.dep.airport] = stubAirport(segment.dep.airport);
      }
      if (!dict.airports[segment.arr.airport]) {
        dict.airports[segment.arr.airport] = stubAirport(segment.arr.airport);
      }
      if (!dict.airlines[segment.airline]) {
        dict.airlines[segment.airline] = stubAirline(segment.airline);
      }
    }
  }

  return dict;
}
